/**
 * Normalize ConnectWise note text for markdown rendering.
 * Notes often store literal `\n` sequences and escaped markdown brackets.
 *
 * @param {string | null | undefined} body
 * @returns {string}
 */
export function normalizeTicketMessageBody(body) {
  if (!body || body === "—") {
    return "";
  }

  let text = String(body);

  if (text.includes("\\n")) {
    text = text.replace(/\\n/g, "\n");
  }

  if (text.includes("\\t")) {
    text = text.replace(/\\t/g, "\t");
  }

  if (text.includes("<")) {
    text = text
      .replace(/<\s*br\s*\/?>/gi, "\n")
      .replace(/<\/\s*(p|div|tr|li)\s*>/gi, "\n")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .trim();
  }

  // Unescape markdown brackets ConnectWise sometimes double-escapes in alt text.
  text = text.replace(/\\(\[|\])/g, "$1");

  return text;
}
